import { render } from "./platform_management.html?vue&type=template&id=4ef2d6c0&external"
import script from "./platform_management.js?vue&type=script&lang=js&external"
export * from "./platform_management.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__